import React from 'react';
import PropTypes from 'prop-types';
import { oneLineTrim } from 'common-tags';

import './StaticMap.module.css';

StaticMap.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,

    mapTitle: PropTypes.string.isRequired,
    latitude: PropTypes.string.isRequired,
    longitude: PropTypes.string.isRequired,
  }).isRequired,
};

function StaticMap({ data }) {
  const { mapTitle, latitude, longitude } = data;

  const staticMapUrl = oneLineTrim`
    https://maps.googleapis.com/maps/api/staticmap?
    center=${latitude},${longitude}
    &zoom=13
    &size=600x300
    &maptype=roadmap
    &scale=2
    &markers=anchor:center|icon:http://montadrill.netlify.com/static_map_icon2.png|${latitude},${longitude}
    &key=AIzaSyAKO-D6amXQquS3ymZEF4qoAKF_Y9eEwNs
  `;

  return (
    <section styleName="StaticMap">
      <h3>{ mapTitle }</h3>
      <a styleName="map" href="https://www.google.com/maps/place/KSS+Handels+e.U/@48.2249397,14.5080592,18.25z/data=!4m5!3m4!1s0x4773ba42a04cca0f:0xc53b65a77e7a210a!8m2!3d48.2254991!4d14.5090958" target="_blank">
        <img src={staticMapUrl} alt="Google Map für Firmenadresse" />
      </a>
    </section>
  );
}

export default StaticMap;



// WEBPACK FOOTER //
// ./src/components/Footer/StaticMap.js